import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store'
import routes from '@/router/routes';
import * as routeConstants from '@/router/constants';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const authRequired = to.matched.some(record => record.meta.requiresAuth);
  const loggedIn = store.getters.isLoggedIn;

  if (authRequired && !loggedIn) {
    next(routeConstants.LOGIN_URL);
  } else if (!authRequired && loggedIn && to.name === 'Login') {
    next(routeConstants.DASHBOARD_URL);
  } else {
    next();
  }
});

export default router;
